/* RA Boutique — cart drawer: one scroll region; original payment controls stay put.
   Phone since 10/2026, computer too since 01/11/2026 (desktop sizes in ra-desktop-parity.css). */
(() => {
  'use strict';
  if (window.RACartScrollLayout) {
    window.RACartScrollLayout.sync();
    return;
  }

  const mobile = window.matchMedia('all');
  const CLASS = 'ra-cart-scroll-layout';
  const MOVABLE = [
    'm-cart-addons', '.m-cart-drawer__gift-wrapping',
    '.m-cart-drawer__summary', '.m-cart__trust-badge',
    '.m-cart-drawer__link-to-cart'
  ].join(',');
  let state = null;
  let observedRoot = null;
  let observer = null;
  let scheduled = false;

  const make = (className) => {
    const node = document.createElement('div');
    node.className = className;
    return node;
  };

  const move = (node, target, before = null) => {
    if (!node || node.parentNode === target) return;
    if (!state.moved.has(node)) {
      const anchor = document.createComment('ra-cart-original-position');
      node.parentNode.insertBefore(anchor, node);
      state.moved.set(node, anchor);
    }
    // Move the existing node, never clone forms, IDs or payment listeners.
    target.insertBefore(node, before);
  };

  const restore = () => {
    if (!state) return;
    const previous = state;
    state = null;
    previous.root.classList.remove(CLASS);
    Array.from(previous.moved.entries()).reverse().forEach(([node, anchor]) => {
      if (anchor.parentNode && previous.root.contains(anchor) && previous.root.contains(node)) {
        anchor.parentNode.insertBefore(node, anchor);
      }
      anchor.remove();
    });
    previous.scroll.remove();
  };

  const collect = () => {
    if (!state) return;
    const { header, footer, messages, summary } = state;
    Array.from(header.children).forEach((node) => {
      if (node.matches('script, style, .m-cart-drawer__title, .m-cart-drawer__close') ||
          node.querySelector('.m-cart-drawer__title, .m-cart-drawer__close')) return;
      move(node, messages);
    });
    footer.querySelectorAll(MOVABLE).forEach((node) => {
      // The checkout/COD controls and their ancestors always stay in the native footer.
      if (node.matches('button, form') ||
          node.querySelector('[name="checkout"], #_rsi-buy-now-button, ._rsi-buy-now-button')) return;
      move(node, summary);
    });
  };

  const mount = (root) => {
    const header = root.querySelector('.m-cart-drawer__header');
    const body = root.querySelector('m-cart-drawer-items[data-minimog-cart-items]');
    const footer = root.querySelector('#MinimogCartDrawerFooter');
    const frame = header?.parentElement;
    if (!header || !body || !footer || !frame ||
        body.parentElement !== frame || footer.parentElement !== frame) return;

    const scroll = make('ra-cart-scroll-region');
    const messages = make('ra-cart-scroll-messages');
    const summary = make('ra-cart-scroll-summary');
    scroll.setAttribute('role', 'region');
    scroll.setAttribute('aria-label', 'Articoli e riepilogo del carrello');
    scroll.setAttribute('tabindex', '0');
    scroll.append(messages, summary);
    frame.insertBefore(scroll, body);
    state = { root, header, body, footer, frame, scroll, messages, summary, moved: new Map() };
    move(body, scroll, summary);
    collect();
    root.classList.add(CLASS);
  };

  const sync = () => {
    scheduled = false;
    const root = document.getElementById('MinimogCartDrawer');
    if (root !== observedRoot) {
      observer?.disconnect();
      observedRoot = root;
      if (root) {
        observer = new MutationObserver(schedule);
        // Native Ajax updates replace innerHTML, not these outer scroll regions.
        observer.observe(root, { childList: true, subtree: true });
      }
    }
    if (state && (state.root !== root || !state.scroll.isConnected ||
        state.body !== root?.querySelector('m-cart-drawer-items[data-minimog-cart-items]') ||
        state.header !== root?.querySelector('.m-cart-drawer__header') ||
        state.footer !== root?.querySelector('#MinimogCartDrawerFooter'))) restore();
    if (!mobile.matches || !root) {
      restore();
      return;
    }
    if (!state) mount(root);
    else collect();
  };

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sync);
  }

  window.RACartScrollLayout = { sync: schedule };
  if (mobile.addEventListener) mobile.addEventListener('change', sync);
  else mobile.addListener(sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else sync();
  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
})();
